import Iconify from './Iconify';

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

const approverNavConfig = [
  {
    title: 'Dashboard',
    path: '/approver/dashboard',
    icon: getIcon('eva:pie-chart-2-fill'),
  },
  {
    title: 'Court Approvals',
    path: '/approver/approval',
    icon: getIcon('eva:file-text-fill'),
  },
  {
    title: 'Cancellations',
    path: '/approver/cancellations',
    icon: getIcon('eva:close-circle-fill'),
  },
  {
    title: 'Ledger',
    path: '/approver/ledger',
    icon: getIcon('fa:book'),
  },
  {
    title: 'Cancellation History',
    path: '/approver/cancellations/history',
    icon: getIcon('eva:book-open-fill'),
  }
];

export default approverNavConfig;
